module.exports = __webpack_public_path__ + "img/Perfil_BuildHome2d.5984942e.png";